<script setup>
import { defineProps } from 'vue'
const props = defineProps({
  phone: {
    type: String,
    required: true
  }
});
</script>

<template>
  <a
      v-if="props.phone"
      :href="'tel:' + props.phone"
      class="inline-flex items-center justify-center space-x-2 px-2 py-1 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600">
    <span class="material-icons-round mr-2" style="font-size: 16px;">phone</span> {{ props.phone }}</a>
  <span v-else>
    <span class="material-icons" style="font-size: 16px;">info</span> No have phone
  </span>
</template>

<style scoped>

</style>